export default {
	Active: 0,
	CancelledPending: 1,
	Cancelled: 2
}